// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import CommonLayout from './../../components/CommonLayout';
import DeviceInformation from './../../components/DeviceInformation/DeviceInformation';
import Warranties from './../../components/Warranties/Warranties';
import { useTranslation } from 'react-i18next';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import history from './../../history';
import { deviceInformationSelector, deviceSelector, deviceWarrantiesSelector, claimDetailSelector } from './../../store/deviceInfo/selectors';
import { getClaimDetails } from './../../store/deviceInfo/deviceInfo';
import Styles from './styles.module.scss';
import ClaimDetails from './../../components/ClaimDetails/ClaimDetails';

export default function WarrantyDetails() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const device = useSelector(state => deviceSelector(state));
    const deviceInformation = useSelector(state =>
        deviceInformationSelector(state)
    );

    if (!deviceInformation) {
        history.push('/');
        return null;
    }

    const warranties = useSelector(state => deviceWarrantiesSelector(state));
    const claimDetails = useSelector(state => claimDetailSelector(state).payload);
    const deviceProps = {
        warranties,
        claimDetails,
        isCreateOrderView: false,
        country: deviceInformation.marketplaceName, //TODO: need to talk to Keith as to which country should be displayed here
        announceTitle: true,
        description: deviceInformation.description,
        deviceName: deviceInformation.repairProduct.name,
        image: deviceInformation.repairProduct.imageUri,
        marketPlace: deviceInformation.marketplaceName,
        partNumber: deviceInformation.partNumber,
        resetPath: '/',
        serialNumber: device.serialNumber,
        seriesName: deviceInformation.msPressSeriesName,
        status: device.status,
        deviceSDTRunDetail: device.deviceSDTRunDetail,
        countryOrigin: device.attributes?.countryOfOrigin,
        color: device.attributes?.color,
    };
    React.useEffect(() => {
        dispatch(
            getClaimDetails({
                serialNumber: device.serialNumber,
            })
        );
    }, [device.serialNumber]);

    return (
        <CommonLayout
            pageTitle={[t('warranty_detail')]}
        >
            <div className={Styles.bodyContainer}>
                <div className={Styles.sectionContainer}>
                    <DeviceInformation {...deviceProps} />
                </div>
                <div id="warranties" className={Styles.sectionContainer}>
                    <Warranties {...deviceProps} />
                </div>
                {
                    claimDetails && claimDetails.length > 0 ?
                        <div id="claimDetails" className={Styles.sectionContainer}>
                            <ClaimDetails claims={claimDetails} />
                        </div>
                        : null
                }
            </div>
        </CommonLayout>
    );
}
